import { render, staticRenderFns } from "./RolesEditor.vue?vue&type=template&id=0d07acda&scoped=true&"
import script from "./RolesEditor.vue?vue&type=script&lang=js&"
export * from "./RolesEditor.vue?vue&type=script&lang=js&"
import style0 from "./RolesEditor.vue?vue&type=style&index=0&id=0d07acda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d07acda",
  null
  
)

export default component.exports